import '../../sass/blocks/_rank-math-faq.scss'

document.querySelectorAll('#rank-math-faq').forEach((faqBlockEl, faqIndex) => {
  const faqBlockElId = `${faqBlockEl.id}--${faqIndex}`
  faqBlockEl.classList.add('rank-math-faq')
  faqBlockEl.id = faqBlockElId

  faqBlockEl.querySelectorAll('.rank-math-list').forEach((faqWrapperEl, faqIndex) => {
    faqWrapperEl.classList.add('accordion')
    const faqItems = faqWrapperEl.querySelectorAll('.rank-math-list-item')
    faqItems.forEach((faqItemEl, index) => {
      const questionId = faqItemEl.id
      const answerId = questionId.replace('question', 'answer')
      faqItemEl.removeAttribute('id')
      faqItemEl.classList.add('accordion-item')

      // add required attributes & classes on question element
      const isExpanded = index === 0
      const questionEl = faqItemEl.querySelector('.rank-math-question')
      if (questionEl) {
        questionEl.id = questionId
        questionEl.classList.add('accordion-header')

        // build button element
        const questionButtonEl = document.createElement('button')
        questionButtonEl.classList.add('accordion-button')
        if (!isExpanded) {
          questionButtonEl.classList.add('collapsed')
        }

        // set required attributes for Bootstrap accordion
        questionButtonEl.setAttribute('data-bs-toggle', 'collapse')
        questionButtonEl.setAttribute('data-bs-target', `#${answerId}`)
        questionButtonEl.setAttribute('aria-expanded', isExpanded.toString())
        questionButtonEl.setAttribute('aria-controls', answerId)

        // swap it with default content
        questionButtonEl.innerHTML = questionEl.innerHTML
        questionEl.innerHTML = ''
        questionEl.append(questionButtonEl)
      }

      // add required attributes & classes on answer element
      const answerEl = faqItemEl.querySelector('.rank-math-answer')
      if (answerEl) {
        // Swap with body container
        const answerBody = document.createElement('div')
        answerBody.classList.add('accordion-body')
        answerBody.innerHTML = answerEl.innerHTML
        answerEl.innerHTML = ''
        answerEl.append(answerBody)

        answerEl.id = answerId
        answerEl.classList.add('accordion-collapse', 'collapse')
        answerEl.setAttribute('data-bs-parent', `#${faqBlockElId} .rank-math-list`)
        answerEl.setAttribute('aria-labelled-by', questionId)
        if (isExpanded) {
          answerEl.classList.add('show')
        }
      }
    })
  })
})
